import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=72bd5e8f&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=72bd5e8f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd5e8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72bd5e8f')) {
      api.createRecord('72bd5e8f', component.options)
    } else {
      api.reload('72bd5e8f', component.options)
    }
    module.hot.accept("./PageFooter.vue?vue&type=template&id=72bd5e8f&scoped=true", function () {
      api.rerender('72bd5e8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/footer/PageFooter.vue"
export default component.exports